import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxUser from "../../util/remote/ajaxUser";

const UpdateNames=(props)=>{

    const [loading, setLoading] = useState(false)
    const [firstName, setFirstName] = useState(props.firstName)
    const [lastName, setLastName] = useState(props.lastName)


    const handleUpdate = async (e) => {
      e.preventDefault();
  
      if (firstName.length > 0 || lastName.length >0) {
        setLoading(true)
        const server_response = await ajaxUser.updateNames(props.userID, firstName, lastName);
        setLoading(false)
        if (server_response.status === "OK") {
          toast.success(server_response.message);
          props.g();
        } else {
          toast.error(server_response.message);
        }
      } else {
        toast.error("Enter both names and try again");
      }
    };
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm Update<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Update Names"
            id="model-update-names"
            size="md"
            footer={RenderFooter}
        >

          <div className="mb-4 col-12 form-group">
            <label htmlFor="">Surname <span style={{color:"red"}}>*</span></label>
            <input
              type="text"
              value={lastName}
              placeholder="Enter last name of student.."
              onChange={(e) => setLastName(e.target.value)}
              className="form-control"
            />
          </div>

          <div className="mb-4 col-12 form-group">
            <label htmlFor="">First Name <span style={{color:"red"}}>*</span></label>
            <input
              type="text"
              value={firstName}
              placeholder="Enter first name of student.."
              onChange={(e) => setFirstName(e.target.value)}
              className="form-control"
            />
          </div>
          
       
        </SystemModal>
    )
}

export default UpdateNames
